import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import SalesByService from './SalesByService';
import ShopUserAppointmentsReportsContainer from '../wrappers/shopUserAppointmentReportsContainer';
import ShopUserSalesReportsContainer from '../wrappers/shopUserSalesReportsContainer';
import PayoutReportContainer from './payouts/containers/PayoutReportContainer';
import ShopUserDepositReportContainer from '../wrappers/shopUserDepositReportContainer';
import DashboardRoutes, { BrandRoutes as DashboardBrandRoutes } from './dashboard/routes';
import DashRoutes from './dash/routes';
import CustomReportRoutes from './customReports/routes';
import RetentionReport from '../wrappers/shopUserRetentionReportContainer';
import BarberUserAppointmentReportWrapper from '../../barber/wrappers/barberUserAppointmentReportWrapper';
import BarberUserSalesReportWrapper from '../../barber/wrappers/barberUserSalesReportWrapper';
import BarberProductSalesReport from '../../barber/wrappers/barberUserProductSalesReportContainer';
import BarberUserDepositReportContainer from '../../barber/wrappers/barberUserDepositReportContainer';
import ShopUserLoanRepaymentReport from '../wrappers/shopUserloanRepaymentReportContainer';
import * as hooks from '../../auth/routerHooks';
import SalesByBarber from './SalesByBarber';
import SalesByBarberBrand from './SalesByBarberBrand';
import SalesByProduct from './SalesByProduct';
import Analytics from './analytics/Analytics';
import TimeTrackReport from './timeTrackReport';
import { RefundsReport, DiscountsReport } from './refundsAndDiscounts';
import BarberSalesSummary from './BarberSalesSummary';
import DailySummary from '../wrappers/brandUserDailySummaryReportWrapper';
import BrandUserAppointmentsReportsContainer from '../../brand/wrappers/brandUserAppointmentReportsContainer';
import SettlementReportRoute from './settlementReport/routes';
import CashRegisterHistory from './CashRegisterHistory/CashRegisterHistory';

const ShopRoutes = store => (
  <Route path="/reports" name="reports" onEnter={hooks.requireReportsViewPermission(store)}>
    <IndexRedirect to="dash" />
    <Route
      path="appointments"
      name="reports.appointments"
      component={ShopUserAppointmentsReportsContainer}
    />
    <Route
      path="sales"
      name="reports.sales"
      component={ShopUserSalesReportsContainer}
    />
    <Route
      path="sales/v2"
      name="reports.sales"
      component={SalesByService}
    />
    <Route
      path="payouts"
      name="reports.payouts"
      onEnter={hooks.requireCommissionSplitReportAbility(store)}
      onChange={(_, ...args) => hooks.requireCommissionSplitReportAbility(store)(...args)}
      component={PayoutReportContainer}
    />
    <Route
      path="deposits"
      name="reports.deposits"
      component={ShopUserDepositReportContainer}
    />
    <Route
      path="retention"
      name="reports.retention"
      component={RetentionReport}
    />
    <Route
      path="barbers"
      name="reports.barbers"
      component={SalesByBarber}
    />
    <Route
      path="barbers-summary"
      name="reports.barbersSummary"
      component={BarberSalesSummary}
    />
    <Route
      path="sales-by-product"
      name="reports.productSales"
      component={SalesByProduct}
    />
    <Route
      path="loan"
      name="reports.loan"
      component={ShopUserLoanRepaymentReport}
    />
    <Route
      onEnter={hooks.requireAnalyticsViewPermission(store)}
      path="analytics"
      name="reports.analytics"
      component={Analytics}
    />
    <Route
      onEnter={hooks.requireTimeReportsViewPermission(store)}
      path="time-track"
      name="reports.timetrack"
      component={TimeTrackReport}
    />
    <Route
      path="refunds"
      name="refunds"
      component={RefundsReport}
    />
    <Route
      path="discounts"
      name="discounts"
      component={DiscountsReport}
    />
    {SettlementReportRoute(store)}
    {DashboardRoutes(store)}
    {DashRoutes(store)}
    {CustomReportRoutes(store)}
  </Route>
);

const BarberRoutes = store => (
  <Route path="reports" name="reports" onEnter={hooks.requireReportsViewPermission(store)}>
    <IndexRedirect to="dashboard/v2" />
    <Route
      path="appointments"
      name="reports.appointments"
      component={BarberUserAppointmentReportWrapper}
    />
    <Route
      path="sales"
      name="reports.sales"
      component={BarberUserSalesReportWrapper}
    />
    <Route
      path="sales-products"
      name="reports.sales"
      component={BarberProductSalesReport}
    />
    <Route
      path="deposits"
      name="reports.deposits"
      component={BarberUserDepositReportContainer}
    />
    <Route
      path="payouts"
      component={PayoutReportContainer}
    />
    <Route
      onEnter={hooks.requireAnalyticsViewPermission(store)}
      path="analytics"
      name="reports.analytics"
      component={Analytics}
    />
    <Route
      path="sales/v2"
      name="reports.sales"
      component={SalesByService}
    />
    <Route
      path="sales-by-product"
      name="reports.productSales"
      component={SalesByProduct}
    />
    {DashboardRoutes(store)}
  </Route>
);

const BrandRoutes = store => (
  <Route
    path="reports"
    name="reports"
    onEnter={hooks.brandReportsRedirectByPermissionCheck(store)}
  >
    <Route
      path="sales-by-product"
      name="reports.productSales"
      component={SalesByProduct}
    />
    <Route
      path="sales/v2"
      name="reports.sales"
      component={SalesByService}
    />
    {DashboardBrandRoutes(store)}
    <Route
      path="barbers"
      name="reports.barbers"
      component={SalesByBarberBrand}
    />
    <Route
      onEnter={hooks.requireAnalyticsViewPermission(store)}
      path="cash-register-history"
      name="reports.cash-register-history"
      component={CashRegisterHistory}
    />
    <Route
      path="analytics"
      name="reports.analytics"
      component={Analytics}
    />
    <Route
      path="payouts"
      name="reports.payouts"
      component={PayoutReportContainer}
    />
    <Route
      path="daily-summary"
      name="reports.dailySummary"
      component={DailySummary}
    />
    <Route
      path="appointments"
      name="reports.appointments"
      component={BrandUserAppointmentsReportsContainer}
    />
    <Route
      onEnter={hooks.requireTimeReportsViewPermission(store)}
      path="time-track"
      name="reports.timetrack"
      component={TimeTrackReport}
    />
    {CustomReportRoutes(store)}
    {SettlementReportRoute(store)}
  </Route>
);

export default {
  ShopRoutes,
  BarberRoutes,
  BrandRoutes,
};
